import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject,ViewChild, ViewEncapsulation } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';
import { CookieService } from 'ngx-cookie-service';
import { CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';
import { RouterExtService } from '../../../services/previous-route.service';
import { NotifierService } from 'angular-notifier';
const now = new Date();
@Component({
  selector: 'app-libarary-news',
  templateUrl: './libarary-news.component.html',
  styleUrls: ['./libarary-news.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LibararyNewsComponent implements OnInit {
  private readonly notifier: NotifierService;
  constructor(@Inject(DOCUMENT) private document: Document, private cookieService: CookieService, private homepageService: HomepageService, private routerService: RouterExtService, notifierService: NotifierService) { 
   this.notifier = notifierService;
  }
  @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;
	bulletinlist : any = [];
	reviews : any = [];
  years: number =  now.getFullYear();
  month: number = now.getMonth()+1;
  closedDays: any[] = [];
  openDays: any[] = [];
  calendarOptions: Options;
  eventsList: any = [];
  eventsEnableList: object = [];
  widgetsSetting: any = [];
  isResponsePage: boolean = false;
  isResponse: boolean = false;
  messageInfo: string;
  isAdmin:boolean = false;
  dateFormat:string = "M/d/yyyy";
  eventTitle:string = '';
  eventDescription:string = '';
  eventDate:string = '';
  eventEndDate:string = '';
  eventLink:string = '';
  eventForDetails:any = [];
  showDetailsCalendar = false;
  checkChangedEvent:string = '';
  locationName:string = '';
  ngOnInit() {
    if(this.cookieService.check('patronPermissions')){
      this.isAdmin = JSON.parse(this.cookieService.get( 'patronPermissions')).opacAdmin;
    }
    this.locationName = location.origin;
  	this.document.body.classList.add('inner-page');
    this.document.body.classList.remove('list');
    this.routerService.setTextUrl('Library News'); 
  	this.getNews();
  }

  getNews(){    
  	this.homepageService.getConfig().subscribe((data) => {
      this.dateFormat = this.homepageService.formatDate();
      //data.data.settings.resultList.maxItems
      if(data.data.settings.news.bulletins){
        this.homepageService.getNewsBulletin(10).subscribe((bulletins) => {
         this.bulletinlist = bulletins.data;
         this.isResponsePage = true;
        }); 
      }
      if(data.data.settings.news.reviews){
        this.homepageService.getNewsReviews(6).subscribe((reviews) => {
         this.reviews = reviews.data;
         this.isResponsePage = true;
        });
      }
      if(data.data.settings.news.calendar){
        this.homepageService.getNewsEvents(this.years,this.month).subscribe((events) => {
          this.eventsList = events.data;
          var lists =  [];
          var i = 0;
          this.cookieService.set('events', JSON.stringify(this.eventsList.events));
          this.closedDays = this.eventsList.closedDates;
          this.eventsList.events.forEach(evt => {
            if(evt.closed === true){
              //this.closedDays[i] = evt.date;
            } else {
              this.openDays[i] = evt.date;
            }
            let getEndDate = new Date(evt.endDate);
            let endDate = getEndDate.setDate(getEndDate.getDate()+1);
            lists[i] = {'title': evt.name,'start' : evt.date, 'end':endDate,  "color" : "pink", 'allDay' : false, 'textColor' : 'white'}
              i++;
            });
            this.eventsEnableList = lists;
            this.calendarOptions = {
              editable: true,
              timezone: 'UTC',
              eventLimit: false,
              showNonCurrentDates: false,
              header: {
                left: 'prev',
                center: 'title',
                right: 'next'
               },
              events: lists
            }; 
          this.isResponse = true;
        });  
      }
    });

  }



  clickButton(data){
      this.isResponse = false;
      var lists =  [];
      var colorinfo = "";
      var extractDate = new Date(data.data);
      this.years =  extractDate.getUTCFullYear();
      this.month =  extractDate.getUTCMonth()+1;
      return this.homepageService.getEvents(this.years,this.month).subscribe((data) => {
          var i = 0;
          this.closedDays = [];
          this.cookieService.set('events', JSON.stringify(data.data.events));
          this.closedDays = data.data.closedDates;
          data.data.events.forEach(evt => {
            if(evt.closed === true){
              //this.closedDays[i] = evt.date;
            } else {
              this.openDays[i] = evt.date;          
            }
            let getEndDate = new Date(evt.endDate);
            let endDate = getEndDate.setDate(getEndDate.getDate()+1);
            lists[i] = {'title': evt.name,'start' : evt.date, 'end': endDate, "color" : "pink", 'allDay' : false,'textColor' : 'white'}              
              i++;
          });
          this.eventsList = data.data;
          this.eventsEnableList = lists;
          this.ucCalendar.renderEvents(lists);    
        this.closedDays.forEach(evt => {
          var today1 = new Date(evt);
          var cDate1 = today1.getDate().toString();
          if(parseInt(cDate1) < 10){
            cDate1 = "0"+cDate1;
          }
          var cMonth1 = (today1.getMonth() + 1).toString();
          if(parseInt(cMonth1) < 10){
            cMonth1 = "0"+cMonth1;
          }
          var cYear1 = today1.getFullYear();
          var rDate1 =  cYear1+'-'+cMonth1+'-'+cDate1;
          $('td[data-date="'+rDate1+'"]').addClass('disabledDay');
        });

      this.openDays.forEach(evt => {
        var today1 = new Date(evt);
        var cDate1 =   today1.getDate().toString();
        if(parseInt(cDate1) < 10){
          cDate1 = "0"+cDate1;
        }
        var cMonth1 = (today1.getMonth() + 1).toString();
        if(parseInt(cMonth1) < 10){
          cMonth1 = "0"+cMonth1;
        }
        var cYear1 = today1.getFullYear();
        var rDate1 =  cYear1+'-'+cMonth1+'-'+cDate1;
        $('td[data-date="'+rDate1+'"]').addClass('openDay');
      });
        this.isResponse = true;
      });
  }

  dayRender(date){
      this.closedDays.forEach(evt => {
        var today1 = new Date(evt);
        var cDate1 =   today1.getDate().toString();
        if(parseInt(cDate1) < 10){
          cDate1 = "0"+cDate1;
        }
        var cMonth1 = (today1.getMonth() + 1).toString();
        if(parseInt(cMonth1) < 10){
          cMonth1 = "0"+cMonth1;
        }
        var cYear1 = today1.getFullYear();
        var rDate1 =  cYear1+'-'+cMonth1+'-'+cDate1;
        $('td[data-date="'+rDate1+'"]').addClass('disabledDay');
      });

 
      this.openDays.forEach(evt => {
        var today1 = new Date(evt);
        var cDate1 =   today1.getDate().toString();
        if(parseInt(cDate1) < 10){
          cDate1 = "0"+cDate1;
        }
        var cMonth1 = (today1.getMonth() + 1).toString();
        if(parseInt(cMonth1) < 10){
          cMonth1 = "0"+cMonth1;
        }
        var cYear1 = today1.getFullYear();
        var rDate1 =  cYear1+'-'+cMonth1+'-'+cDate1;
        $('td[data-date="'+rDate1+'"]').addClass('openDay');
      });

      var  weekdays = [0,1, 2, 3, 4, 5,6];        

        weekdays.forEach(evt => {
            var isHave = this.eventsList.closedDaysOfWeek.indexOf(evt);
            if(isHave >= 0){
              $('.fc-content-skeleton').find('thead tr td:eq('+evt+')').addClass('closeDays');
            }
        });
  }


     imageError(event){
      $('body').find('span.NW').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('span.NW').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('span.NW').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
      $('body').find('span.NW').find('img[custom="'+event+'"]').remove();
    }
  
   imageLoad(event, images) {
    if($('body').find('span.NW').find('img[custom="'+event+'"]').attr('loaded') == 'yes') {
      return false;
    }
     var sizes = ['xl','l','m','s','xs','xxs'];
     if($('body').find('#TempImg').length <= 0) {
       $('body').append('<img id="TempImg" src="" style="display:none;">');
     }
     var imagesAll = [];

     sizes.forEach((evt) => {
      images.forEach((img) => {
        if(img.size == evt){
          imagesAll.push(img.url);
        }
      });      
    });
     
    setTimeout(function() {
      if(typeof(imagesAll[0]) != 'undefined') {
        $('body').find('span.NW').find('img[custom="'+event+'"]').attr('src',imagesAll[0]);
        $('body').find('span.NW').find('img[custom="'+event+'"]').attr('loaded','yes');        
      } 
    },10);
  }

  showDetails(description, title, date, endDate, link){
    this.eventTitle = title;
    this.eventDescription = description;
    this.eventDate = date;
    this.eventEndDate = endDate;
    this.eventLink = link;
    //$('#calendarDetail').addClass('show in').show();
  }

  eventClick(detail){
    if(this.cookieService.check('events')){
      var events = JSON.parse(this.cookieService.get('events'));
      var eventToShow = [];
      events.forEach((val,key)=>{
        if(detail.event.start._i == val.date){
          eventToShow.push(val);
        }
      });
      this.eventForDetails = eventToShow;
      this.eventDescription = this.eventForDetails[0].description;
      this.eventLink = this.eventForDetails[0].bulletinId;
      this.showDetailsCalendar = true;
      //console.log(this.eventForDetails);
    }else{
      this.eventForDetails = [];
    }
  }

  hideDetailsCalendar(){
    this.showDetailsCalendar = false;
  }

  currentEvent(event:any){
    var tempIdCal:any = $(event.target).val();
    this.eventDescription = this.eventForDetails[tempIdCal].description;
    this.eventLink = this.eventForDetails[tempIdCal].bulletinId;

  }
  
}
